import type { AnalyticsRange, CreatorAnalytics } from '../types';
import { getCreators } from './creators-api';
import type { AnalyticsDto } from './creators-api.types';
import { mapAnalyticsDto } from './dashboard.mapper';

/** Analytics for a period, both days inclusive. */
export async function fetchCreatorAnalytics(
	range: AnalyticsRange,
): Promise<CreatorAnalytics> {
	return mapAnalyticsDto(
		await getCreators<AnalyticsDto>('analytics', {
			from: range.from,
			to: range.to,
		}),
	);
}
